import { createTheme } from '@one-thd/sui-atomic-components';

const MothersDayPrimaryTwo = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

MothersDayPrimaryTwo.palette['--sui-palette-background-primary'] = '133 122 171';
MothersDayPrimaryTwo.palette['--sui-palette-button-background-primary'] = '255 255 255';
MothersDayPrimaryTwo.palette['--sui-palette-text-primary'] = '255 255 255';
MothersDayPrimaryTwo.palette['--sui-palette-text-subtle'] = '255 255 255';

export { MothersDayPrimaryTwo };
